var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'bottom-sidenav-logo-container': true,
    'cursor-pointer': !_vm.isOnSCDC,
  },on:{"click":_vm.handleLogoClicked}},[_c('div',{staticClass:"bottom-sidenav-logo"},[_c('p',[_vm._v("Powered by")]),_vm._v(" "),_c('base-image',{staticClass:"px-2",attrs:{"src":_vm.logoUrl}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }